import React from 'react';
import { Navigate, Outlet } from 'react-router-dom'
import { useLocation } from 'react-router';
import TokenService from '../utility'

type ProtectedRouteTypes = {
    roleRequired?: 'ADMIN' | 'USER',
}

const useAuth = () => {
    const token = TokenService.getLocalAccessToken()
    const _user = TokenService.getTokenUser()

    if (_user && token) {
        return {
            auth: true,
            role: _user.is_superuser ? 'ADMIN' : 'USER'
        }
    } else {
        return {
            auth: false,
            role: null
        }
    }
}

const naviateTo = (props: any, auth: any, role: any, location: any) => {
    if (auth) {
        return <Navigate replace to="/login" state={{ from: location }} />
    }

    return props.roleRequired === role ? <Outlet /> : <Navigate replace to="/login" state={{ from: location }} />
}
const PrivateRoute = (props: ProtectedRouteTypes) => {
    const { auth, role } = useAuth();
    const location = useLocation();

    if (props.roleRequired) {
        return naviateTo(props, auth, role, location)
    } else {
        return auth ? <Outlet /> : <Navigate replace to="/login" state={{ from: location }} />
    }
}

export default PrivateRoute